/**
 * useSendTemplate Hook
 * Hook para enviar mensagem template em uma conversa via React Query mutation.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as chatService from '@/modules/chat/services/chatService';

export const useSendTemplate = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (d: {
      conversationId: string;
      templateId: string;
      variables: Record<string, string>;
    }) => chatService.sendTemplate(d),
    onSuccess: (_res, vars) => {
      // Invalidar mensagens infinitas da conversa para recarregar o histórico
      qc.invalidateQueries({ queryKey: ['messages', 'infinite', vars.conversationId] });
      // Invalidar lista de conversas para atualizar lastMessage
      qc.invalidateQueries({ queryKey: ['conversations'], exact: false });
      // ⚠️ B8 (review 2026-07-27): este refetch NÃO reabre a janela de 24h —
      // mensagem do negócio (mesmo template) nunca conta pra política da Meta
      // (spec §2.1 corolário 1: "Mensagem do negócio não conta — nem free-form,
      // nem template"). O backend grava este envio com `senderType: 'user'`
      // (`sendTemplateToConversation` em conversation-messages/service.ts), que
      // `createMessage` só trata como inbound/reabertura quando `senderType`
      // é `'contact'` — então `lastMessageFromCustomer` NÃO muda aqui, e
      // useMessagingWindow permanece em 'window_closed' até o cliente responder
      // de verdade. O motivo real deste invalidate é só manter outros campos
      // server-side da conversa em dia (status, lastMessage, etc.) após o envio.
      qc.invalidateQueries({ queryKey: ['conversation', vars.conversationId] });
    },
  });
};
